<template>
  <v-layout :wrap="$vuetify.breakpoint.smAndDown">
    <v-flex md4>
      <v-flex>
        <v-autocomplete
          ref="provinceFilter"
          v-model="chosenFilters.province"
          append-icon="expand_more"
          item-value="province.province_id"
          item-text="province.name"
          :label="$t('label.province')"
          :items="availableWioStructs"
          :filter="filteredLocations"
          :disabled="availableWioStructsLength <= 1"
        />
      </v-flex>
      <v-flex>
        <v-autocomplete
          ref="warehouseType"
          v-model="chosenFilters.warehouse_type"
          append-icon="expand_more"
          item-value="value"
          item-text="name"
          :label="$t('label.warehouse_type.type')"
          :items="warehouseTypeItems"
          :disabled="warehouseTypeItemsLength <= 1"
        />
      </v-flex>
    </v-flex>
    <v-flex md4>
      <v-layout
        fill-height
        column
        :align-center="$vuetify.breakpoint.smAndDown"
        :align-start="$vuetify.breakpoint.mdAndUp"
      >
        <v-btn
          color="sz_violet"
          class="mr-0 ml-1 mt-3 text-none border-none"
          flat
          :outline="isButtonDisabled"
          :disabled="isButtonDisabled"
          @click="filtered"
        >
          <BaseIcon>
            <FiltersIcon />
          </BaseIcon>
          {{ $t('filters.filter') }}
        </v-btn>
        <v-btn
          color="sz_violet"
          class="mr-0 ml-1 mt-3 text-none border-none"
          flat
          :outline="isButtonDisabled"
          :disabled="isButtonDisabled"
          @click="resetFilters"
        >
          {{ $t('buttons.reset_filters') }}
        </v-btn>
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
import BaseIcon from '@/icons/BaseIcon';
import FiltersIcon from '@/icons/FiltersIcon';
import permissions from '@/constants/permissions';

import isEmpty from 'lodash.isempty';

export default {
    name: 'WarehouseFilters',
    components: { BaseIcon, FiltersIcon },
    data () {
        return {
            permissions,
            chosenFilters: {
                warehouse_type: null,
                province: null
            },
            canCreateRejonWarehouse: null,
            canCreateSupportingWarehouse: null,
            regionalWarehouseListView: null,
            supportingWarehouseListView: null,
            warehouseTypeItems: []
        };
    },
    computed: {
        availableWioStructs () {
            return this.$store.getters['defaultApi/getAvailableWioStructs'];
        },
        availableWioStructsLength () {
            return this.availableWioStructs && this.availableWioStructs.length;
        },
        warehouseTypeItemsLength () {
            return this.warehouseTypeItems && this.warehouseTypeItems.length;
        },
        isFilterEmpty () {
            const filters = {};
            for (const [key, value] of Object.entries(this.chosenFilters)) {
                if (value && value.length !== 0) {
                    filters[key] = value;
                }
            }
            return isEmpty(filters);
        },
        isButtonDisabled () {
            return (
                this.isFilterEmpty ||
        (this.availableWioStructsLength <= 1 && this.warehouseTypeItemsLength <= 1)
            );
        }
    },
    watch: {
        availableWioStructs: {
            handler (val) {
                if (val.length === 1) {
                    this.chosenFilters.province = val[0].province.province_id;
                }
            },
            immediate: true
        }
    },
    async created () {
        this.createWarehouseTypes();

        const filtersParams = this.$store.getters['warehouses/getPagination'].filtersParams;
        if (filtersParams != null) {
            if (filtersParams.province) {
                this.chosenFilters.province = filtersParams.province;
            }
            if (filtersParams.warehouse_type) {
                this.chosenFilters.warehouse_type = filtersParams.warehouse_type;
            }
        }
        this.canCreateRejonWarehouse = await this.$store.dispatch(
            'auth/hasPermission',
            this.permissions.ADD_REGIONAL_WAREHOUSE
        );
        this.canCreateSupportingWarehouse = await this.$store.dispatch(
            'auth/hasPermission',
            this.permissions.ADD_SUPPORTING_WAREHOUSE
        );
        if (!this.canCreateRejonWarehouse && !this.canCreateSupportingWarehouse) {
            await this.$store.dispatch('defaultApi/getAvailableWioStructs');
        }
    },
    methods: {
        filteredLocations (item, query) {
            return item.province.name.toLocaleLowerCase().indexOf(query.toLocaleLowerCase()) > -1;
        },
        filtered () {
            this.$emit('filtered', this.chosenFilters);
        },
        resetFilters () {
            this.reset();
            this.resetWarehouseType();
            this.filtered();
        },
        reset () {
            if (this.availableWioStructsLength > 1) {
                this.chosenFilters.province = null;
            }
            this.hide();
        },
        resetWarehouseType () {
            if (this.warehouseTypeItems.length > 1) {
                this.chosenFilters.warehouse_type = null;
            }
            this.hideWarehouseType();
        },
        hide () {
            this.$refs.provinceFilter.blur();
        },
        hideWarehouseType () {
            this.$refs.warehouseType.blur();
        },
        async createWarehouseTypes () {
            this.regionalWarehouseListView = await this.$store.dispatch(
                'auth/hasPermission',
                this.permissions.WAREHOUSE_REGIONAL_LIST_VIEW
            );
            this.supportingWarehouseListView = await this.$store.dispatch(
                'auth/hasPermission',
                this.permissions.WAREHOUSE_SUPPORTING_LIST_VIEW
            );
            if (this.regionalWarehouseListView) {
                this.warehouseTypeItems.push({
                    value: 'regional',
                    name: this.$t('label.warehouse_type.regional')
                });
            }
            if (this.supportingWarehouseListView) {
                this.warehouseTypeItems.push({
                    value: 'supporting',
                    name: this.$t('label.warehouse_type.supporting')
                });
            }
            if (this.warehouseTypeItemsLength === 1) {
                this.chosenFilters.warehouse_type = this.warehouseTypeItems[0].value;
            }
        }
    }
};
</script>

<style scoped>
.sticky {
  position: sticky;
  bottom: 0;
  background: #fff;
  border-top: 1px solid #9da0a1;
}
.border-none {
  border: 0 !important;
}
</style>
